import Badge from "../../components/Badge";
import Avatar from 'react-avatar';
import ActionButton from "./ActionButton";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {useState} from "react";
import {Link} from "react-router-dom";
import {DateTimeOptionsMediumShort} from "../../utils/DateTimeOptions";
import NoneValue from "../../components/NoneValue";
import CopyToClipBoard from "../../components/CopyToClipBoard";

function ProductGroup({productGroup}) {
    const productGroupUrl = productGroup.product_url;
    const productGroupHref = productGroupUrl && /^https?:\/\//i.test(productGroupUrl)
        ? productGroupUrl
        : productGroupUrl
            ? `https://${productGroupUrl}`
            : null;
    const shortProductGroupUrl = productGroup.short_product_group_url;
    const shortProductGroupHref = shortProductGroupUrl && /^https?:\/\//i.test(shortProductGroupUrl)
        ? shortProductGroupUrl
        : shortProductGroupUrl
            ? `https://${shortProductGroupUrl}`
            : null;
    const renderCopyableLink = (url, href) => {
        if (url === null) {
            return <NoneValue/>;
        }

        return (
            <CopyToClipBoard link={href}>
                <a href={href} target="_blank" rel="noopener noreferrer">
                    {url}
                </a>
            </CopyToClipBoard>
        );
    };

    const [productGroupDetailsModal, setProductGroupDetailsModal] = useState(false);
    const productGroupDetailsModalToggle = () => setProductGroupDetailsModal(!productGroupDetailsModal);
    const [expandedProducts, setExpandedProducts] = useState(false);

    const productsModalExpansion = () => {
        setExpandedProducts(!expandedProducts);
    };
    const visibleProducts = productGroup.products.slice(0, 3);
    const hiddenProductsCount = Math.max(productGroup.products.length - 3, 0);

    return (
        <>
            <tr>
                <td>

                    {productGroup.image ? <img src={productGroup.image}
                                          className="avatar-sm img-thumbnail rounded-circle" alt={"productGroup"}/>
                        : <Avatar size={35} name={productGroup.name} round/>}

                </td>
                <td onClick={productGroupDetailsModalToggle}>
                    <Link className="text-primary">{productGroup.name}</Link>
                </td>
                <td className="text-muted font-13">{productGroup.price}</td>
                <td className="text-muted font-13">
                    {renderCopyableLink(shortProductGroupUrl, shortProductGroupHref)}
                </td>
                <td style={{ display: 'flex', alignItems: 'center', gap: "4px" }}>
                    {visibleProducts.map(product => (
                        <div key={product.id} title={product.name}>
                            {product.image ? (
                                <img src={product.image} className="avatar-sm img-thumbnail rounded-circle" alt={product.name} />
                            ) : (
                                <Avatar size={35} name={product.name} round />
                            )}
                        </div>
                    ))}
                    <span className="badge badge-light-primary">{productGroup.products.length} items</span>
                    {hiddenProductsCount > 0 ? (
                        <span onClick={() => {
                            productGroupDetailsModalToggle()
                            productsModalExpansion()
                        }}
                              style={{ cursor: 'pointer' }}>

                            <div
                                style={{
                                    width: '35px',
                                    height: '35px',
                                    backgroundColor: 'grey',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    color: 'white',
                                    fontSize: '12px',
                                }}
                                title={productGroup.products.slice(3).map(product => product.name).join(', ')}
                            >
                                {`+${hiddenProductsCount}`}
                            </div>
                        </span>
                    ) : null}
                </td>

                <td>
                    <Badge badge={
                        productGroup.status === "ACTIVE"
                            ? "badge badge-light-success"
                            : "badge badge-light-danger"
                    } status={productGroup.status}/>
                </td>
                <td>{new Date(productGroup.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                <ActionButton productGroup={productGroup}/>
            </tr>

            <Modal className={'modal-xl'} isOpen={productGroupDetailsModal} toggle={productGroupDetailsModalToggle}>
                <ModalHeader toggle={productGroupDetailsModalToggle} close={
                    <button className="close" onClick={productGroupDetailsModalToggle}>
                        &times;
                    </button>
                }>Product Group details</ModalHeader>
                <ModalBody>
                    <div className="card-box">
                        <h4 className="header-title">{productGroup.name}</h4>
                        <p className="sub-header">

                                {productGroup.image ? <img src={productGroup.image}
                                                      className="avatar-xl img-thumbnail rounded-circle" alt={"productGroup"}/>
                                    : <Avatar size={95} name={productGroup.name} round/>}
                        </p>

                        <div className="table-responsive">
                            <table className="table mb-0">

                                <tbody>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Product Group ID</td>
                                    <td>{productGroup.id}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Product Group Name</td>
                                    <td>{productGroup.name}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Price</td>
                                    <td>{productGroup.price}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Product Group URL</td>
                                    <td>{renderCopyableLink(productGroupUrl, productGroupHref)}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Short Product Group URL</td>
                                    <td>{renderCopyableLink(shortProductGroupUrl, shortProductGroupHref)}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Add-Ons Supported</td>
                                    <td>{productGroup.add_ons_supported?.count ?? <NoneValue/>}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Price After Tax</td>
                                    <td>{productGroup.price_after_tax}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Description</td>
                                    <td>{productGroup.description === "" ? <NoneValue/>: productGroup.description}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Included Products</td>
                                    <td>
                                        <div className="mb-2">
                                            <span className="badge badge-light-primary">{productGroup.products.length} items</span>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: "8px" }}>
                                            {productGroup.products.slice(0, 4).map((product, index) => (
                                                <div key={product.id} title={product.name} style={{ display: 'flex', alignItems: 'center', gap: "8px" }}>
                                                    <span style={{ minWidth: '24px' }}>{index + 1}.</span>
                                                    {product.image ? (
                                                        <img src={product.image} className="avatar-sm img-thumbnail rounded-circle" alt={product.name} />
                                                    ) : (
                                                        <Avatar size={35} name={product.name} round />
                                                    )}
                                                    <span>{product.name}</span>
                                                </div>
                                            ))}
                                            {productGroup.products.length > 4 && (
                                          <>
                                            {expandedProducts
                                            ? productGroup.products.slice(4).map((product, index) => (
                                                    <div key={product.id} title={product.name} style={{ display: 'flex', alignItems: 'center', gap: "8px" }}>
                                                        <span style={{ minWidth: '24px' }}>{index + 5}.</span>
                                                        {product.image ? (
                                                            <img src={product.image} className="avatar-sm img-thumbnail rounded-circle" alt={product.name} />
                                                        ) : (
                                                            <Avatar size={35} name={product.name} round />
                                                        )}
                                                        <span>{product.name}</span>
                                                    </div>
                                            ))
                                            : null}
                                              <span onClick={productsModalExpansion} style={{ cursor: 'pointer' }}>
                                                <div
                                                    style={{
                                                    width: '35px',
                                                    height: '35px',
                                                    backgroundColor: 'grey',
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    color: 'white',
                                                    fontSize: '12px',
                                                    }}
                                                >
                                                    {productGroup.products.length > 4 && !expandedProducts ? `+${productGroup.products.length - 4}` : "-"}
                                                </div>
                                              </span>
                                          </>
                                        )}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Status</td>
                                    <td><Badge badge={
                                        productGroup.status === "ACTIVE"
                                            ? "badge badge-light-success"
                                            : "badge badge-light-danger"
                                    } status={productGroup.status}/></td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>HSN/SAC</td>
                                    <td>{productGroup.hsn_sac === "" ? <NoneValue/> : productGroup.hsn_sac}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Unit of Measure</td>
                                    <td>{productGroup.unit_of_measure === "" ? <NoneValue/> : productGroup.unit_of_measure}</td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Tax Type</td>
                                    <td>{productGroup.tax_type}</td>

                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Tax Percentage</td>
                                    <td>{productGroup.tax_percentage} %</td>

                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td>Tax Amount</td>
                                    <td>{productGroup.tax_amount}</td>
                                </tr>
                                {/*<tr>*/}
                                {/*    <th scope="row"></th>*/}
                                {/*    <td>Price Before Tax</td>*/}
                                {/*    <td>{productGroup.price_before_tax}</td>*/}
                                {/*</tr>*/}
                                {/*<tr>*/}
                                {/*    <th scope="row"></th>*/}
                                {/*    <td>Owner</td>*/}
                                {/*    <td>{productGroup.owner}</td>*/}
                                {/*</tr>*/}
                                <tr>
                                    <th scope="row"></th>
                                    <td>Created</td>
                                    <td>{new Date(productGroup.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Updated</td>
                                    <td>{new Date(productGroup.updated).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>

    );
}

export default ProductGroup;
